import React from 'react';
import './say.css';
import { LinguistOptions, speakSample } from '../chart/speakSample';

interface LinguistProps {
  /** what to say */
  readonly phoneme: string;
  /** who should say it */
  readonly linguist?: LinguistOptions;
}

/** shows a phoneme segment you can click on to hear it spoken */
export function Linguist(props: LinguistProps) {
  function onClick() {
    speakSample(props.phoneme, props.linguist);
  }

  const name = props.linguist === 'JH' ? 'J. House'
    : props.linguist === 'PL' ? 'P. Ladefoged'
      : props.linguist === 'JW' ? 'J. Wells'
        : 'J. Esling';

  const playButton = '\u23f5';
  return (<span onClick={onClick} className='linguist'>
    {playButton}
    {name}
  </span>);
}
